export const userRole = {
    GlobalAdmin: 1,
    BusinessUnitAdmin: 2,
    BusinessUnitUser: 3
};

export const blobType = {
    Folder: "Folder",
    File: "File",
    Link: "Link",
};